// extracted by mini-css-extract-plugin
module.exports = {"container":"LoaderFullSize_container__rcRn5"};